/* file description */

import { useSetState } from 'ahooks';
import { useCallback, useEffect } from 'react';
import { useSPTableWithModelSchemaReturnType } from './useSPTableWithModelSchema';

interface InitPropsType {
  spRecordListSchema: useSPTableWithModelSchemaReturnType['spRecordListSchema'];
}

export const useInit = ({
  spRecordListSchema,
}: InitPropsType) => {
  const [searchParams, setSearchParams] = useSetState<Record<string, any>>({});
  // 重置搜索默认值
  const makeSearchParams = useCallback((columns) => {
    const dval: Record<string, any> = {};
    columns.forEach((col) => {
      if (col?.defaultValue) {
        dval[col.dataIndex] = col?.defaultValue;
      }
    });
    return dval;
  }, []);

  useEffect(() => {
    const val: Record<string, any> = {};
    spRecordListSchema.forEach((recordSchema) => {
      const colums = recordSchema?.children[0]?.props?.columns || [];
      const moduleId = recordSchema?.children[0]?.props.moduleID || '';
      const transformParams = makeSearchParams(colums);
      val[moduleId] = transformParams;
    });
    setSearchParams(val);
  }, []);

  return {
    searchParams,
    setSearchParams,
  };
};
